const state = {
  list: [],
  selectedAllowListEntry: null,
};

const getters = {
  customerAllowList: (state) => state.list,
  selectedAllowListEntry: (state) => state.selectedAllowListEntry,
};

const actions = {
  async fetchCustomerAllowListEntry({ commit }, { id, policyId, allowId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/allow/${allowId}?user_id=${id}`
    );

    commit("addAllowListEntry", response.data);
    commit("setSelectedAllowListEntry", response.data);
  },

  async fetchCustomerAllowList({ commit }, { id, policyId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/domains/allow?user_id=${id}`
    );

    commit("setCustomerAllowList", response.data.data);
  },

  async createCustomerAllowListEntry({ commit }, { id, policyId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/allow?user_id=${id}`,
      body
    );

    commit("addAllowListEntry", response.data);
  },

  async updateCustomerAllowListEntry(
    { commit },
    { id, policyId, allowId, body }
  ) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/domains/allow/${allowId}?user_id=${id}`,
      body
    );

    const index = state.list.findIndex(
      (allowEntry) => allowEntry.id === response.data.id
    );

    if (index === -1) {
      commit("addAllowListEntry", response.data);
    } else {
      commit("updateAllowListEntry", {
        idx: index,
        locationAddress: response.data,
      });
    }
  },

  async importCustomerAllowListEntries({ commit }, { id, policyId, body }) {
    const response = await this._vm.$http.post(
      `/restapi/policies/${policyId}/domains/allow?user_id=${id}`,
      body
    );

    commit("importAllowListEntries", response.data);
  },

  async deleteCustomerAllowListEntries({ commit }, { id, policyId, allowId }) {
    const response = await this._vm.$http.delete(
      `/restapi/policies/${policyId}/domains/allow/${allowId}?user_id=${id}`
    );

    commit("deleteLocationAddress", response.data);
  },
};

const mutations = {
  setCustomerAllowList: (state, data) => (state.list = data),
  setSelectedAllowListEntry: (state, data) =>
    (state.selectedAllowListEntry = data),
  addAllowListEntry: (state, data) => state.list.push(data),
  updateAllowListEntry: (state, data) =>
    (state.list[`${data.idx}`] = data.locationAddress),
  importAllowListEntries: (state, data) =>
    (state.list = [...state.list, ...data]),
  deleteLocationAddress: (state, data) => {
    state.list = state.list.filter((domain) => {
      return domain.id !== parseInt(data.id);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
